export default __webpack_public_path__ + "static/media/card-image5.08c87d23.png";